<template>
    <div class="card card-style has-width-500">
    <div class="card-header">
      <div class="card-header-title">
        <h2>
          Dangerous Goods Management Web Portal
          <br>
          <span style="font-size: 16px; font-weight: normal;">- Contact Support -</span>
        </h2>
      </div>
    </div>
    <div >
        <div class="has-padding-top-30 has-text-primary">
            Thanks for contacting NIMASA Support, Please fill this form clearly stating the issues we need to address
        </div>
      <form action method="POST" @submit.prevent="supportMail">
        <validation-observer
          ref="supportMailObserver"
          tag="div"
          v-slot="{invalid, valid, untouched, errors}"
        >
          <div class="columns flex-column has-margin-top-20">
            <!-- Name of sender -->
            <div class="column is-12">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Full Name'"
                rules="required"
                v-model="name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Email of sender -->
            <div class="column is-12">
              <input-with-validation
                :name="'email'"
                :errorLabel="'email'"
                :label="'Email Address'"
                rules="required|email"
                v-model="email"
                :type="'text'"
                :vid="'email'"
              ></input-with-validation>
            </div>

            <!-- Subject of the support mail -->
            <div class="column is-12">
              <input-with-validation
                :name="'subject'"
                :errorLabel="'subject'"
                :rules="'required'"
                :label="'Subject'"
                v-model="subject"
                :type="'text'"
                :vid="'subject'"
              ></input-with-validation>
            </div>

            <div class="column is-12">
              <input-with-validation
                :name="'message'"
                :errorLabel="'message'"
                :rules="'required'"
                :label="'Message'"
                v-model="message"
                :type="'textarea'"
              ></input-with-validation>
            </div>

            <div class="column is-12">
              <button
                class="button is-primary is-full-width has-margin-bottom-20"
                :class="{'is-loading': loading, 'is-disabled': loading}"
              >
                <span>Send</span>
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SupportMailMutation from "@/modules/commonModule/api/graphql/mutations/SupportMail.gql"
export default {
    name: "support-form",
    components: {InputWithValidation, ValidationObserver},
data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      loading: false
    };
  },

  methods: {
    /**
     * Signup the shipper
     */
    supportMail: async function() {
      const isValid = await this.$refs.supportMailObserver.validate();
      if (!isValid) {
        return;
      }

      const supportMailInput = {
        name: this.name,
        subject: this.subject,
        email: this.email,
        message: this.message
      };
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: SupportMailMutation,
          variables: {
            input: supportMailInput
          }
        })
        .then(response => {
          const status_code = response.data.SupportMail.status_code;
          if(status_code == 200){
          this.$toast.open({
            duration: 6000,
            message: `${this.name} Your Support Email, has been sent successfully.`,
            type: "is-black",
          });

          this.name = "";
          this.email = "";
          this.subject = "";
          this.message = "";

          this.$parent.close();
          }
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not send your mail at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>


<style scoped>
.card-header-title,
h2 {
  font-family: "Poppins";
  text-align: center;
  justify-content: center;
  color: #3c5081;
  font-size: 1.1em;
  font-weight: bold !important;
  max-width: 300px;
  margin: 0 auto;
}

.card-style {
  padding: 1em;
  border: 1px solid #3c5081;
}
</style>
